import { render, staticRenderFns } from "./IconView.vue?vue&type=template&id=045dd2b2&scoped=true"
import script from "./IconView.vue?vue&type=script&lang=js"
export * from "./IconView.vue?vue&type=script&lang=js"
import style0 from "./IconView.vue?vue&type=style&index=0&id=045dd2b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045dd2b2",
  null
  
)

export default component.exports